<div>
<!-- <body> -->
    <div>
        <div style="margin-left: 80%; margin-top: -4%; margin-bottom: 2%">
            <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
                color="primary" printSectionId="print-section" ngxPrint>
                print
            </button>
            <!-- <button mat-raised-button class="btn btn-info noPrint" (click)="print()"
                style="margin-right: 2%; margin-left: 2%">
                Print
            </button> -->
            <button mat-dialog-close class="btn noPrint">
                Close
            </button>
        </div>
        <!-- <div class="container" id="print-section">
            <div style="margin: 0 15px;">
                <div class="row" style="font-weight: 700;">
                    <div class="col1" style="border-width: 1px 1px 1px 1px;font-weight: 700;">Receipt No</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Date</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Sub. No</div>
                    <div class="col1" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Subscription Name</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Place</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Sub. Type</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Is Receipt</div>
                    <div class="col1" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Period</div>
                    <div class="col1" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Rep. Name</div>
                    <div class="col1" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Off. Rep. Name</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Edition</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Total Amt.</div>
                    <div class="col" style="border-width: 1px 1px 1px 0px;font-weight: 700;">Discount</div>
                </div>
                <div class="row" *ngFor="let item of data">
                    <div class="col1" style="border-width: 0px 1px 1px 1px;">{{ item.rcpt_no }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.crdt_voucher_date | date:"dd-MM-yyyy" }}
                    </div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.subno }}</div>
                    <div class="col1" style="border-width: 0px 1px 1px 0px;">{{ item.name }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.district }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.subscription_type }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.rcpt_type }}</div>
                    <div class="col1" style="border-width: 0px 1px 1px 0px;">{{ item.sub_perid_to_date |
                        date:"dd-MM-yyyy" }} - {{ item.sub_perid_from_date | date:"dd-MM-yyyy" }}</div>
                    <div class="col1" style="border-width: 0px 1px 1px 0px;">{{ item.rep_name }}</div>
                    <div class="col1" style="border-width: 0px 1px 1px 0px;">{{ item.office_rep_name }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.magzine_edition }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.total_amt }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ item.discount }}</div>
                </div>
                <div class="row">
                    <div class="col1" style="border-width: 0px 1px 1px 1px;font-weight: 700;text-align: center;">Total
                    </div>
                    <div class="col" style="border-width: 0px 0px 1px 0px;">
                    </div>
                    <div class="col" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col1" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col1" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col1" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col1" style="border-width: 0px 0px 1px 0px;"></div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;"></div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ total_amt }}</div>
                    <div class="col" style="border-width: 0px 1px 1px 0px;">{{ total_discount }}</div>
                </div>
            </div>
        </div> -->


        <div class="container" id="print-section">
  <table border="1" cellspacing="0" cellpadding="5" style="width:100%; border-collapse: collapse; text-align: left; table-layout: auto;">
    <thead>
        <tr>
            <th colspan="14" style="text-align: center; font-size: 16px; font-weight: bold;"> हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक वर्गणी विभाग रिपोर्ट 
            </th>
        
        </tr>
        <tr>
            <th colspan="14" style="text-align: center; font-size: 15px; font-weight: bold;"> ग्राहक पावती लेजर </th>
        </tr>
        
      <tr style="font-weight: 700;">
        <th style="border-width: 2px 2px 2px 2px;font-weight: bold; font-size: 14; text-align: center;"> अ.क्र.</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">पावती क्र.</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">दिनांक</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">ग्राहक .क्र</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">वर्गणीदार नाव</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">ठिकाण</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">वर्गणी प्रकार</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">नवीन/नूतनीकरण</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">वैद्य दिनांक</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">प्रतिनिधी</th>
        <th style="border-width: 2px 2px 2px 1px;font-weight: bold; font-size: 14; text-align: center;">ऑफिस प्रतिनिधी</th>
        <th style="border-width: 2px 2px 2px 2px;font-weight: bold; font-size: 14; text-align: center;">वितरण प्रकार</th>
        <th style="border-width: 2px 2px 2px 2px;font-weight: bold; font-size: 14; text-align: center;">वितरण दिनांक</th>
        <th style="border-width: 2px 2px 2px 2px;font-weight: bold; font-size: 14; text-align: center;">रक्कम</th>
        <!-- <th style="border-width: 1px 1px 1px 1px;font-weight: bold; font-size: 14; text-align: center;">सूट</th> -->
      </tr>  
    </thead>
    <tbody>
      <tr *ngFor="let item of data; let i = index">
        <td style="padding: 8px; text-align: right; border-width: 1px 1px 1px 2px;">{{i + 1}}</td>
        <td style="text-align: left; white-space: nowrap; ">{{ item.rcpt_no }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.crdt_voucher_date | date:"dd-MM-yyyy" }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.subno }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.name }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.district }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.subscription_type }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.rcpt_type }}</td>
        
        <!-- <td style="text-align: left; white-space: nowrap;">{{ item.display_sub_from_date | date:"dd-MM-yyyy" }} - {{ item.display_sub_to_date | date:"dd-MM-yyyy" }}</td> -->

        <td style="text-align: left; white-space: nowrap;">
  {{
    (
      item['sub_perid_from_date1'] &&
      item['sub_perid_from_date1'] !== '' &&
      item['sub_perid_from_date1'] !== '0000-00-00'
        ? item['sub_perid_from_date1']
        : item['sub_perid_from_date']
    ) | date:'dd-MM-yyyy'
  }}
  -
  {{
    (
      item['sub_perid_from_date1'] &&
      item['sub_perid_from_date1'] !== '' &&
      item['sub_perid_from_date1'] !== '0000-00-00'
        ? item['sub_perid_to_date1']
        : item['sub_perid_to_date']
    ) | date:'dd-MM-yyyy'
  }}
</td>
        
        <td style="text-align: left; white-space: nowrap;">{{ item.rep_name }}</td>
        <td style="text-align: left; white-space: nowrap;">{{ item.office_rep_name }}</td>
        <td style="text-align: right; white-space: nowrap;">{{ item.delivery_mode }}</td>
        <td style="text-align: right; white-space: nowrap;">{{ item.publish_date }}</td>
        <td style="text-align: right; white-space: nowrap; border-width: 1px 2px 1px 1px;">{{ formatAmount(item.total_amt) }}</td>
        <!-- <td style="text-align: right; white-space: nowrap;">{{ item.discount }}</td> -->
      </tr>
      <tr style="font-weight: 700; text-align: center;">
        <td style="border-width: 2px 2px 2px 2px;font-weight: 700; white-space: nowrap;">एकूण</td>
        <td colspan="12" style="border-width: 2px 2px 2px 2px;"></td>
        <td style="border-width: 2px 2px 2px 2px; font-weight: 700; white-space: nowrap;">{{ total_amt }}</td>
        <!-- <td>{{ total_discount }}</td> -->
      </tr>
    </tbody>
  </table>
</div>

    </div>
<!-- </body> -->

<div style="margin-left: 40%;">

    <button class="noPrint"
        style="margin-right: 1%; margin-left: 1%; margin-top: 2%;"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

    <button class="noPrint" style="margin-top: 2%; margin-left: 1%; margin-right: 2%;"
        (click)="exportExcel('Subscriber Receipt Ledger Report')" mat-raised-button color="primary">
        Export
    </button>

    <!-- <button [useExistingCss]="true"
        style="margin-right: 2%; margin-left: 2%; margin-top: 2%; font-size: 12px; font-weight: 600;" mat-raised-button
        color="primary" printSectionId="print-section" ngxPrint>
        Print
    </button> -->

    <button mat-dialog-close class="btn" style="margin-right: 2%; margin-left: 1%; margin-top: 2%; font-size: 14px; font-weight: 600;">Close</button>
</div>
</div>